export const APP_ROOT_URL = '/ai-create-store';
export const CATEGORIES_URL = '/';
export const TEMPLATE_SELECTION_URL = '/template';
export const STORE_NAME_URL = '/choose-store-name';
export const SITE_PREVIEW_URL = '/site-preview';
export const DOMAIN_URL = '/domain';
